(ns practitest.frontend.testset2.testsets-instances-grid
  (:require
   [ajax.core :as ajax]
   [clojure.string :as str]
   [practitest.frontend.common-entities :refer [common-index-grid-props]]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.common-entities.events :as common-events] ;; Forms version 3 support
   [practitest.frontend.common.format-utils :as fu]
   [practitest.frontend.common.i18n :refer [format-translation get-translation] :as i18n]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [practitest.frontend.common.permissions :as permissions]
   [practitest.frontend.common.re-frame :refer [partial-dispatch]]
   [practitest.frontend.components.card-view]
   [practitest.frontend.components.grid.events :as grid.events]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
   [practitest.frontend.components.grid.subs :as grid.subs]
   [practitest.frontend.components.icons :as icons] 
   [practitest.frontend.components2.grid :as grid2]
   [practitest.frontend.components2.grid.row-menu :refer [row-menu]]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.testset2.events :as testset2 :refer [testsets-instances-state-key]]
   [practitest.frontend.testset2.set-instance-parameters :as set-params]
   [practitest.frontend.testset2.subs :as testset.subs]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]))

(def table-id "testset2-testsets-instances-grid")

(defn testsets-instances-grid
  [form-props grid-state & {:keys [instances-toolbar]}]
  (let [{:keys [edit?
                edit-permissions?
                expanded?]} form-props
        current-project @(re-frame/subscribe [::subs/current-project])
        testset-id @(re-frame/subscribe [::subs/current-entity-id :testset])
        disabled-action-menu? (not (permissions/has-permission? "runs_admin"))
        set-params-new-ui? @(re-frame/subscribe [::subs/set-parameters-new-ui-enabled?])
        is-instance-view-mode? true
        post-columns (when edit?
                       [{:header        ""
                         :field         :actions
                         :default-width 50
                         :width         50
                         :type          :custom
                         :text-align    :center
                         :resizable?    false
                         :sortable?     false
                         :systemcol?    true
                         :class         ["action-menu"]
                         :cell-fn       (fn [_column-info row]
                                          [row-menu row disabled-action-menu?
                                           [{:label    (get-translation "generic.button.edit" "Edit")
                                             :icon     icons/mux-pencil
                                             :href     (:url row)
                                             ;; TODO: fix this
                                             :on-click (fn [] (mixpanel/track "Grid Actions" {"Action" "Edit Instance"}))}

                                            {:label        (get-translation "generic.button.delete" "Delete")
                                             :icon         icons/mux-trash
                                             :disabled?    (not (permissions/has-permission? "instances_admin"))
                                             :on-click (fn []
                                                         (mixpanel/track "Grid Actions" {"Action" "Delete Instance"})
                                                         (re-frame/dispatch [::testset2/delete-instance (:id row) is-instance-view-mode?]))
                                             :confirmation {:title (get-translation "instance.delete-confirmation.title"
                                                                                    "Delete Instance?")
                                                            :body (format-translation
                                                                   (get-translation "instance.delete-confirmation.body"
                                                                                    "\"%{object-name}\" will be deleted permanently.")
                                                                   :object-name (fu/truncate-text (:title row) 30))
                                                            :yes-label (get-translation "generic.button.delete"
                                                                                        "Delete")
                                                            :no-label (get-translation "generic.button.cancel"
                                                                                       "Cancel")}}

                                            {:label     (get-translation "instance.menu.set-parameters" "Set Parameters")
                                             :icon      icons/mux-parameters-set
                                             :disabled? (not (permissions/has-permission? "runs"))
                                             :on-click  (fn []
                                                          (if set-params-new-ui?
                                                            (do (mixpanel/track "Form Actions" {"Action" "Batch_Set_Parameters"})
                                                                (re-frame/dispatch [::set-params/show-modal #{(:id row)} testset-id]))
                                                            (do (mixpanel/track "Grid Actions" {"Action" "Batch Set Parameters"})
                                                                (dom/navigate! (broutes/get-url "steps_params#index"
                                                                                                {:project_id (:id current-project)}
                                                                                                {:ids (str (:id row))
                                                                                                 :set_id testset-id})))))}]])}])

        instances-columns (map
                           (fn [column]
                             (if (or (= :linked-entities (:type column))
                                     (= :test_type (:type column)))
                               ;; Override default linked issues behavior to be sortable
                               (assoc column :sortable? true)
                               column))
                           @(re-frame/subscribe [::grid.subs/columns [:testset :testsets-instances-grid]])) 
        table-id-with-testset (str (:id current-project) "-" table-id "-" testset-id)
        table-id-entity (str (:id current-project)  "-" table-id)
        pre-columns []
        instance-dialog-table-id (str (:id current-project) "-add-instances-dialog")
        grid-props {:testset-grid?         true
                    :fields                @(re-frame/subscribe [::subs/fields])
                    :columns               instances-columns
                    :pre-columns           pre-columns
                    :post-columns          post-columns

                    :class                 "data-grid-instances"
                    :grid-state            grid-state
                    :show-edit-columns?    true
                    :data                  @(re-frame/subscribe [::grid.subs/data [:testset testsets-instances-state-key]])

                    ;; Reused existing one
                    :selected?             #(re-frame/subscribe [::grid.subs/selected? [:testset testsets-instances-state-key] %])
                    :all-selected?         #(re-frame/subscribe [::grid.subs/all-selected? [:testset testsets-instances-state-key] %])
                    :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [:testset testsets-instances-state-key]])
                    :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [:testset testsets-instances-state-key]])

                    :current-page          @(re-frame/subscribe [::testset.subs/testsets-instances-current-page])
                    :total-count           @(re-frame/subscribe [::testset.subs/testsets-instances-total-count])
                    :full-data?            @(re-frame/subscribe [::testset.subs/testsets-instances-full-data?])
                    :on-query-changed      (partial-dispatch [::common-events/fetch-entity-list :testset testsets-instances-state-key])

                    :per-page-save         (reagent/partial grid-storage/save-per-page table-id-with-testset)
                    :per-page-load         (reagent/partial grid-storage/load-per-page table-id-with-testset)
                    :per-page-instances-grid-load (reagent/partial grid-storage/load-per-page instance-dialog-table-id)
                    :current-page-save     (reagent/partial grid-storage/save-current-page table-id-with-testset)
                    :current-page-load     (reagent/partial grid-storage/load-current-page table-id-with-testset)
                    :save-in-url?          true 

                    :resizable?            true
                    :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id-with-testset)
                    :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id-with-testset)
                    :columns-settings-save (reagent/partial grid-storage/save-column-settings table-id-with-testset)
                    :columns-settings-load (reagent/partial grid-storage/load-column-settings table-id-with-testset)

                    :autofilters-save      (reagent/partial grid-session-storage/save-autofilters table-id-with-testset)
                    :autofilters-load      (reagent/partial grid-session-storage/load-autofilters table-id-with-testset)
                    :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id-with-testset)
                    :sort-order-load       (reagent/partial grid-session-storage/load-sort-order table-id-with-testset)

                    :empty-table-message   (get-translation "testset.instances.add-instances-to-your-testset"
                                                            "Add Instances to your test set and start running")
                    ;; For filters
                    :get-field-props       #(re-frame/subscribe [::subs/field-props :instance %])
                    :show-fast-run         (:show_fast_run current-project)
                    :show-save-fast-filter? false
                    :grid-toolbar          (fn [grid-props]
                                             ;; partial doesn't work here (most likely because instances-toolbar is form-2 component
                                             [instances-toolbar form-props grid-props])

                    :on-expand-click       (partial-dispatch [::common-events/toggle-expanded :testset testsets-instances-state-key])
                    :expanded?             expanded?
                    :loading?              @(re-frame/subscribe [::subs/progress? ::common-events/fetch-entity-list])
                    :select-all            nil}

        grid-props (merge (common-index-grid-props :testset testsets-instances-state-key table-id-with-testset)
                          grid-props)]
    [:div.entities-grid
     [grid2/grid grid-props]]))

(re-frame/reg-event-fx
 ::sort-instances
 (fn [{:keys [db]} [_ newitems]]
   (let [payload (map #(select-keys % [:id :name]) newitems)
         uri (broutes/get-url "instances#sort"
                              {:p_id   (get-in db [:current-project :id])
                               :set_id (get-in db [:entity :testset :current :id])})]
     {:db (update db :progress conj ::sort-instances)
      :http-xhrio
      {:method          :post
       :uri             uri
       :params          payload
       :format          (ajax/json-request-format)
       :response-format (ajax/raw-response-format)
       :on-success      [::sort-instances-success]
       :on-failure      [::sort-instances-failure]}})))
